module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.0003ab07.svg";